import React, { useRef } from 'react';
import useResizeObserver from 'use-resize-observer';
import { motion } from 'framer-motion';

/* Constants */
import { easeInOut } from '~/constants/transitions'

export default function AnimateHeight({ children }) {
    const heightRef = useRef(null);
    const { height } = useResizeObserver({ ref: heightRef });

    return (
        <motion.div animate={{ height: height }} transition={easeInOut}>
            <div className="d-inline-block" ref={heightRef}>
                {children}
            </div>
        </motion.div>
    );
}
